import React from 'react';

export const BookmarkGray600Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.33334 2.91675C2.33334 2.45262 2.51772 2.0075 2.84591 1.67931C3.1741 1.35112 3.61921 1.16675 4.08334 1.16675H9.91668C10.3808 1.16675 10.8259 1.35112 11.1541 1.67931C11.4823 2.0075 11.6667 2.45262 11.6667 2.91675V12.2664C11.6667 12.9781 10.8617 13.3922 10.283 12.9787L7.00001 10.6337L3.71701 12.9787C3.13776 13.3928 2.33334 12.9787 2.33334 12.267V2.91675ZM4.08334 2.33341C3.92863 2.33341 3.78026 2.39487 3.67086 2.50427C3.56147 2.61367 3.50001 2.76204 3.50001 2.91675V11.7L6.49134 9.56325C6.63976 9.45721 6.81761 9.4002 7.00001 9.4002C7.18242 9.4002 7.36026 9.45721 7.50868 9.56325L10.5 11.7V2.91675C10.5 2.76204 10.4386 2.61367 10.3292 2.50427C10.2198 2.39487 10.0714 2.33341 9.91668 2.33341H4.08334Z"
        fill="#333333"
      />
    </svg>
  );
};
